var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var initState = {
    errorData: {
        error: null,
        isOpen: false,
    },
};
export var EXT_PLAT_DATA_RETRIVE_ERROR = "EXT_PLAT_DATA_RETRIVE_ERROR";
//export const JWT_TOKEN_NEST_TRADER_SHIMMER = "JWT_TOKEN_NEST_TRADER_SHIMMER";
export var EXT_PLAT_DATA_RETRIVE_HIDE_ERROR = "EXT_PLAT_DATA_RETRIVE_HIDE_ERROR";
export var ExtPlatDataRetriveErrorEnum;
(function (ExtPlatDataRetriveErrorEnum) {
    ExtPlatDataRetriveErrorEnum["ERROR_DATA"] = "errorData";
})(ExtPlatDataRetriveErrorEnum || (ExtPlatDataRetriveErrorEnum = {}));
var extPlatDataRetrieveReducer = function (state, action) {
    var _a, _b;
    if (state === void 0) { state = initState; }
    switch (action.type) {
        case EXT_PLAT_DATA_RETRIVE_ERROR:
            return __assign(__assign({}, state), (_a = {}, _a[action.errorType] = action.payload.errorData, _a));
        case EXT_PLAT_DATA_RETRIVE_HIDE_ERROR:
            return __assign(__assign({}, state), (_b = {}, _b[action.errorType] = initState[action.errorType], _b));
        default:
            return __assign({}, state);
    }
};
export default extPlatDataRetrieveReducer;
